export type Caisse = "CIAM" | "CIEPP" | "CIFA" | "CIAN" | "CIAB" | "CIGA" | "CVCI";

export const CAISSE_LIST = ["CIAM", "CIFA", "CIAN", "CIAB", "CIGA", "CVCI"] as Caisse[];
